import { Injectable } from '@angular/core';
import { RestCallService } from '../../../../core/services/rest-call/rest-call.service';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from '../../../../core/translate/translate-application-service';
import { CognitoService } from 'src/app/core/services/cognito/cognito.service';
import { IVisitorVehicle } from '../Interfaces/IVisitorVehicle';

@Injectable({
	providedIn: 'root',
})
export class VisitorsVehiclesService extends RestCallService {

	public dataToSend: IVisitorVehicle ={
        pkvisit: 0,
        pk_visitor_vehicle: 0,
        fk_visitor: 0,
        brand: '',
        model: '',
        color: '',
        license_plate: '',
        creation_date: new Date(),
        str_creation_date: '',
        fk_employee_creator: 0,
        last_updated:  new Date(),
        str_last_updated: '',
        fk_employee_updater: 0,
        available: false,
        editable: false,
        employee_creator_name: '',
        employee_updater_name: '',
        username: '',
        fk_employee: 0,
        site: '',
        fk_site: 0,
    };

	constructor(
		public httpClient: HttpClient,
		private cognitoService: CognitoService,
		public toastr: ToastrService,
		public notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		super(httpClient, 'JACSapi', toastr, notificationService, translate);
	}

	public GetList(pkvisit: number) {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		this.dataToSend.pkvisit = pkvisit;
		this.dataToSend.fk_site = Number(localStorage.getItem('pksite'));
		return this.post<IVisitorVehicle[]>('/api/VisitorsVehicles/GetVisitorsVehicle', this.dataToSend);
	}

	public AddVisitorVehicle(data: any, pk_visitor_vehicle:number) {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		this.dataToSend.pk_visitor_vehicle = pk_visitor_vehicle;
		this.dataToSend.fk_visitor = data.cbVisitOwner;
    this.dataToSend.brand = data.txtVehicleBrand.trim();
    this.dataToSend.model = data.txtVehicleModel.trim();
    this.dataToSend.color = data.txtColor.trim();
    this.dataToSend.license_plate = data.txtLicensePlate.trim();
    this.dataToSend.pkvisit = data.pkvisit;
		this.dataToSend.fk_site = Number(localStorage.getItem('pksite'));
		return this.post('/api/VisitorsVehicles/AddVisitorVehicle', this.dataToSend);
	}

	public ChangeStatusVehicle(pk_visitor_vehicle: number, available:boolean) {
		if (!this.cognitoService.IsAuhtenticated())
			this.cognitoService.LogOut();
		this.dataToSend.pk_visitor_vehicle = pk_visitor_vehicle;
		this.dataToSend.available = available;
        this.dataToSend.fk_site = Number(localStorage.getItem('pksite'));
		return this.put('/api/VisitorsVehicles/ChangeStatusVehicle', this.dataToSend);
  }

  public GetAvailableVehiclesByVisitor(data: any) {
    
    this.dataToSend.fk_visitor = data.pkVisitor;
    this.dataToSend.pkvisit = data.pkVisit;
    this.dataToSend.fk_site = Number(localStorage.getItem('pksite')) == 0 ? data.fkSite : Number(localStorage.getItem('pksite'));
		return this.post<IVisitorVehicle[]>('/api/VisitorsVehicles/GetAvailableVehiclesByVisitor', this.dataToSend);
  }
}
